.Convo {
  list-style-type: none;
  position: relative;

  & > span {
    position: absolute;
    top: 10px;
    left: -20px;
    color: #d63384;
    font-size: 1.5rem;
    line-height: 0rem;
  }
}
